import React from 'react'

import Beers from './pages/beers'
import NewBeers from './pages/new-beers'
import Event from './components/organisms/Event'
import Article from './components/organisms/Article'
import Authors from './components/organisms/Author'
import Faqs from './pages/faqs'
import Generic from './pages/generic'
import Home from './pages/home'
import VisitUsPage from './pages/visitus'
import TheBreweryPage from './pages/brewery'
import MenuPage from './pages/menu'
import WelcomeBackPage from './pages/welcome-back'
import HomeDeliveryPage from './pages/home-delivery'
import CompetitionPage from './pages/competition'
import TermsAndConditionsPage from './pages/terms-and-conditions'
import TheUselessBrewPage from './pages/theuselessbrew'
export default [
  {
    title: 'Home',
    mobileTitle: 'Open Gate Brewery',
    path: '/',
    apiPath: 'homePage',
    key: 'homePage',
    additionalKeys: [
      { title: 'latestBeers', name: 'theBeersPageData' },
      { title: 'latestEvents', name: 'eventsPageData' },
      { title: 'signUpForm', name: 'signUpFormData' }
    ],
    component: props => <Home {...props} />
  },
  {
    title: 'The beers',
    path: '/the-beers',
    apiPath: 'theBeersPage',
    key: 'theBeersPage',
    additionalKeys: [{ title: 'beersFilter', name: 'theBeersFilterData' }],
    mobileTitle: 'Discover unique beers',
    component: props => <Beers {...props} />
  },
  {
    title: 'The beers',
    path: '/beers',
    apiPath: 'beerPage',
    key: 'beerPage',
    additionalKeys: [{ title: 'beersFilter', name: 'theBeersFilterData' }],
    mobileTitle: 'Discover unique beers',
    component: props => <NewBeers {...props} />
  },
  {
    title: 'The brewery',
    path: '/the-brewery',
    apiPath: 'theBreweryPage',
    key: 'theBreweryPage',
    mobileTitle: 'The brewery',
    additionalKeys: [{ title: 'signUpForm', name: 'signUpFormData' }],
    className: 'Brewery',
    component: props => <TheBreweryPage {...props} />
  },
  {
    title: 'Event',
    path: '/events/:eventId',
    apiPath: 'Data__Events',
    mobileTitle: 'Events',
    key: 'Event',
    additionalKeys: [{ title: 'signUpForm', name: 'signUpFormData' }],
    component: props => <Event {...props} pageID='pageEvent' />
  },
  {
    title: 'Events',
    path: '/events',
    apiPath: 'Page__Events',
    mobileTitle: 'Events',
    key: 'Events',
    additionalKeys: [{ title: 'signUpForm', name: 'signUpFormData' }],
    component: props => <Generic {...props} pageID='pageEventsList' />
  },
  {
    title: 'Event2',
    path: '/events_new/:eventId',
    apiPath: 'Data__Events2',
    mobileTitle: 'Events',
    key: 'Event',
    additionalKeys: [{ title: 'signUpForm', name: 'signUpFormData' }],
    component: props => <Event {...props} pageID='pageEvent' />
  },
  {
    title: 'Events2',
    path: '/events_new',
    apiPath: 'Page__Events',
    mobileTitle: 'Events',
    key: 'Events',
    additionalKeys: [{ title: 'signUpForm', name: 'signUpFormData' }],
    component: props => <Generic {...props} pageID='pageEventsList' />
  },
  {
    title: 'Faqs',
    path: '/faqs',
    apiPath: 'faqsPage',
    key: 'faqsPage',
    mobileTitle: 'Help & Information',
    component: props => <Faqs {...props} />
  },
  {
    title: 'Article',
    path: '/journal/:journalId',
    apiPath: 'Data__Journal',
    mobileTitle: 'Journal',
    key: 'Article',
    additionalKeys: [{ title: 'signUpForm', name: 'signUpFormData' }],
    component: props => <Article {...props} pageID='pageJournal' />
  },
  {
    title: 'Journal',
    path: '/journal',
    apiPath: 'Page__Journal',
    mobileTitle: 'Journal',
    key: 'Journal',
    additionalKeys: [{ title: 'signUpForm', name: 'signUpFormData' }],
    component: props => <Generic {...props} pageID='pageJournalList' />
  },
  {
    title: 'Author',
    path: '/authors/:authorId',
    apiPath: 'Page__Journal',
    mobileTitle: 'Author',
    key: 'Authors',
    additionalKeys: [{ title: 'signUpForm', name: 'signUpFormData' }],
    component: props => <Authors {...props} pageID='pageAuthor' />
  },
  {
    title: 'Food',
    path: '/small-plates',
    apiPath: 'Food',
    mobileTitle: 'Food',
    key: 'Food',
    additionalKeys: [{ title: 'signUpForm', name: 'signUpFormData' }],
    component: props => <MenuPage {...props} pageID='pageMenu' />
  },
  {
    title: 'The Useless Brew',
    path: '/theuselessbrew',
    apiPath: '',
    mobileTitle: 'The Useless Brew',
    key: 'The Useless Brew',
    additionalKeys: [{ title: 'signUpForm', name: 'signUpFormData' }],
    component: props => <TheUselessBrewPage {...props} pageID='pageTheUselessBrew' />
  },
  {
    title: 'Terms and Conditions',
    path: '/terms-and-conditions',
    apiPath: '',
    mobileTitle: 'Terms and Conditions',
    key: 'Terms and Conditions',
    additionalKeys: [{ title: 'signUpForm', name: 'signUpFormData' }],
    component: props => <TermsAndConditionsPage {...props} pageID='pageTermsAndConditions' />
  }
]



// WEBPACK FOOTER //
// ./src/routes.js